import { render, staticRenderFns } from "./PlotEdit.vue?vue&type=template&id=079e4abf"
import script from "./PlotEdit.vue?vue&type=script&lang=ts"
export * from "./PlotEdit.vue?vue&type=script&lang=ts"
import style0 from "./PlotEdit.vue?vue&type=style&index=0&id=079e4abf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports